/* Plain (non-client) module so server components get the real strings.
   Importing these from CtaLink ("use client") in a server component yields a
   client reference, which stringified into a 404 signup href on prod. */
export const STUDIO_URL = 'https://studio.launchlemonade.app';
export const STUDIO_LOGIN_URL = `${STUDIO_URL}/login`;
/* New visitors go here. The bare STUDIO_URL 307s signed-out visitors to /login (#22). */
export const STUDIO_SIGNUP_URL = `${STUDIO_URL}/signup`;

/* A typed task goes to the studio as ?prompt=, the only handoff it reads
   (#7277). The old `slug`/`selected_task` cookies were never read, so a
   typed task was lost (#7698). */
export function signupUrlWithPrompt(prompt: string): string {
  const q = prompt.trim();
  return q ? `${STUDIO_SIGNUP_URL}?prompt=${encodeURIComponent(q)}` : STUDIO_SIGNUP_URL;
}
